import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import FlyoutContent from "./FlyoutContent";
import TypographyPoppins from "../../Atoms/TypographyPoppins";
import { BreadcrumbRightArrow } from "../../../public/Theme";
import { sendGTMEvent } from "@next/third-parties/google";

const FlyoutLink = ({ text, link, flyoutLinks, headerId }) => {
    const [open, setOpen] = useState(false);
    const showFlyout = flyoutLinks && open;
    return (
        <div
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            className=" w-fit h-full"
        >
            <li className=" relative flex items-center w-40 h-full justify-center cursor-pointer scal">
                <Link
                    href={link || ""}
                    passHref
                    onClick={() =>
                        sendGTMEvent({
                            event: "NavigationInteractions",
                            menu_name: text,
                            place: "topnavcollectionmenu",
                        })
                    }
                >
                    <TypographyPoppins
                        size={"sm"}
                        fontWeight={"medium"}
                        text={text}
                        customStyle={`!capitalize !text-white ${showFlyout ? "scale-125" : ""}`}
                    />
                </Link>
                <AnimatePresence>
                    {showFlyout && (
                        <motion.div
                            layoutId="underline"
                            className="absolute bottom-0 left-0 right-0 h-[2px] bg-white"
                            transition={{
                                type: "spring",
                                stiffness: 300,
                                damping: 30,
                            }}
                        />
                    )}
                </AnimatePresence>
            </li>

            <AnimatePresence>
                {showFlyout && (
                    <motion.div
                        initial={{ opacity: 0, zIndex: 9999, top: 60 }}
                        animate={{ opacity: 1, zIndex: 9999, top: 45 }}
                        exit={{ opacity: 0, zIndex: 9999, top: 60 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                        className="absolute w-screen top-8 -left-0 z-10"
                    >
                        <div className=" w-full h-[19px] bottom-0 right-0"></div>
                        <div className=" w-full px-20 py-7 bg-White_Smoke">
                            <FlyoutContent
                                links={flyoutLinks}
                                headerId={headerId}
                            />
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default FlyoutLink;
